module.exports = ".chipestado {\n  justify-content: center;\n  margin: 0 !important;\n  width: 110px !important; }\n"